import { combineReducers } from 'redux';

import usuari from './usuari';
import dataActual from './data';
import observacio from './observacio';
import avis from './avis';
import estacio from './estacio';
import municipis from './municipis';
import peticioDataActualEnCurs from './peticioDataActualEnCurs';
import login from './login';


const rootReducer = combineReducers({
    usuari,
    dataActual,
    observacio,
    avis,
    estacio,
    municipis,
    peticioDataActualEnCurs,
    login
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js